import {useState,useEffect} from "react";
import { Link ,useLocation, useOutletContext } from "react-router-dom";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import GameSvcCtntCtxtApi from "Apis/GameSvcCtntCtxtApi";
import GamePageBanner from "Components/GamePageBanner";
import { Helmet } from "react-helmet-async";
import "Assets/css/Ctnt.css"
import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { sanitizeContent } from 'Utils/sanitizeConfig';
import NoDataUi from "Views/Comm/NoDataUi";
import MgpStore from "Stores/Store";
import FaqCtgrLstInqApi from "Apis/FaqCtgrLstInqApi";

import "Assets/css/Cs.css";
import { BorderTop } from "@mui/icons-material";


const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&::before': {
      display: 'none',
    },
  }));
  
  const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
  ))(({ theme }) => ({
  //   backgroundColor: 'rgba(0, 0, 0, .03)',
  //   flexDirection: 'row-reverse',
  //   '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
  //     transform: 'rotate(90deg)',
  //   },
  //   '& .MuiAccordionSummary-content': {
  //     marginLeft: theme.spacing(1),
  //   },
  //   ...theme.applyStyles('dark', {
  //     backgroundColor: 'rgba(255, 255, 255, .05)',
  //   }),
  }));
  
  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));

const GamePrbbUi = ({gameSvcCd,ctntKindCd,ctntCtgrCdName}:any) => {
    const { gameMainPageData, langData }:any = useOutletContext();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [faqCtgrLstState,setFaqCtgrLstState] = useState([]);
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntLstState,setCtntLstState] = useState<any>([]);
    const [faqCtgrCdState,setFaqCtgrCdState] = useState("");
    const [expandedCategory, setExpandedCategory] = useState<string>("");
    const [selectedCtntSno, setSelectedCtntSno] = useState<string>("");
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
        
    let test1:any;
    const [expanded, setExpanded] = React.useState<string | false>('panel1');

    // 모바일 카테고리 메뉴 열림 시 body 스크롤 방지
    useEffect(() => {
        if (isMobileCategoryOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileCategoryOpen]);
    
    const handleChange =
    (panel: string,GameSvcCd:string,ctntSno:string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setCtntCtxtState("");
        setExpanded(newExpanded ? panel : false);
        GameSvcCtntCtxtApi(GameSvcCd,ctntSno)
        .then((Resp) => {
            const dirty = Resp.apiBody.ctntCtxt;
            test1 = sanitizeContent(dirty);
            setCtntCtxtState(test1);
        })
    };
    const location= useLocation();  
        const serchParamsFunc = () => {
            return new URLSearchParams(location.search);
        }
        let query =serchParamsFunc();
        let getGameSvcCd = query.get("gameSvcCd");
        let getctntKindCd = query.get("ctntKindCd");
        if(getGameSvcCd !=null){
            gameSvcCd = getGameSvcCd;
            ctntKindCd = getctntKindCd;
        }
    
        if(gameSvcCd ==null) {
            gameSvcCd = location.state?.gameSvcCd;
        }
        if(ctntKindCd ==null) {
            ctntKindCd = location.state?.ctntKindCd;
        }
    const [ctntKindCdState,setCtntKindCdState] = useState<any>();
    const guideBannerUrl = gameMainPageData?.menu?.find((menu: any) => {
        const menuUrl = menu?.url?.toLowerCase() || '';
        const menuCd = menu?.menuCd?.toUpperCase() || '';

        if (menuUrl.includes('/gamepage/gameguide') || menuCd === 'GGUID') {
            return true;
        }

        return menu?.subMenuLst?.some((sub: any) => {
            const subUrl = sub?.url?.toLowerCase() || '';
            const subCd = sub?.menuCd?.toUpperCase() || '';
            const urlParams = new URLSearchParams(sub?.url?.split('?')[1] || '');
            const subCtntKindCd = (urlParams.get('ctntKindCd') || '').toUpperCase();

            return subUrl.includes('/gamepage/gameguide') || subCd === 'GGUID' || subCtntKindCd === 'GGUID';
        });
    })?.bnrUrl;
    useEffect(()=>{
        FaqCtgrLstInqApi(gameSvcCd,"prbb").then((resp)=> {
            setFaqCtgrLstState(resp.apiBody.ctgrLst);
            
            // 첫 번째 카테고리 설정
            const firstCategory = resp.apiBody.ctgrLst[0];
            setFaqCtgrCdState(firstCategory.ctgrCd);
            setExpandedCategory(firstCategory.ctgrCd);
            
            GameSvcCtntPstdLstInqApi(gameSvcCd,"PRBB",pageState,"",firstCategory.ctgrCd).then((resp)=> {
                setPageState(resp.apiBody.nowPageNo)
                setOnePageSizeState(resp.apiBody.onePageSize)
                setTotPstdCntState(resp.apiBody.totCnt)
                setCtntLstState(resp.apiBody.ctntLst);
                
                // 첫 번째 아코디언 자동 선택
                if (resp.apiBody.ctntLst.length > 0) {
                    const firstItem = resp.apiBody.ctntLst[0];
                    setSelectedCtntSno(firstItem.ctntSno);
                    
                    GameSvcCtntCtxtApi(gameSvcCd, firstItem.ctntSno)
                    .then((Resp) => {
                        setCtntCtxtState(Resp.apiBody.ctntCtxt);
                    });
                }
            });
        })
      },[MgpStore.getState().LangSetState.Lang])
      
      const FaqCtgrChngFunc = (faqCtgrCd:string) => {
        // 같은 카테고리 클릭 시 아무것도 하지 않음 (토글 방지)
        if (expandedCategory === faqCtgrCd) {
            return;
        }
        
        setExpandedCategory(faqCtgrCd);
        setFaqCtgrCdState(faqCtgrCd);
        GameSvcCtntPstdLstInqApi(gameSvcCd,"PRBB",pageState,"",faqCtgrCd).then((resp)=> {
            setPageState(resp.apiBody.nowPageNo)
            setOnePageSizeState(resp.apiBody.onePageSize)
            setTotPstdCntState(resp.apiBody.totCnt)
            setCtntLstState(resp.apiBody.ctntLst);
            
            // 첫 번째 아이템 자동 선택
            if (resp.apiBody.ctntLst.length > 0) {
                const firstItem = resp.apiBody.ctntLst[0];
                setSelectedCtntSno(firstItem.ctntSno);
                GameSvcCtntCtxtApi(gameSvcCd, firstItem.ctntSno)
                .then((Resp) => {
                    setCtntCtxtState(Resp.apiBody.ctntCtxt);
                    // 컨텐츠 영역이 화면 상단보다 위에 있을 경우에만 스크롤
                    const contentArea = document.querySelector('.faqCtxtLstWrap');
                    if (contentArea) {
                        const yOffset = -90;
                        const targetY = contentArea.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        if (contentArea.getBoundingClientRect().top < 90) {
                            window.scrollTo({ top: targetY, behavior: 'smooth' });
                        }
                    }
                });
            }
        });
      }
      
      const handleAccordionClick = (ctntSno: string, event?: React.MouseEvent) => {
        // 이벤트 버블링 방지
        if (event) {
            event.stopPropagation();
        }
        
        // 같은 아코디언 클릭 시 아무것도 하지 않음
        if (selectedCtntSno === ctntSno) {
            return;
        }
        
        setSelectedCtntSno(ctntSno);
        setIsMobileCategoryOpen(false);
        GameSvcCtntCtxtApi(gameSvcCd, ctntSno)
        .then((Resp) => {
            setCtntCtxtState(Resp.apiBody.ctntCtxt);
            // 컨텐츠 영역이 화면 상단보다 위에 있을 경우에만 스크롤
            const contentArea = document.querySelector('.faqCtxtLstWrap');
            if (contentArea) {
                const yOffset = -90;
                const targetY = contentArea.getBoundingClientRect().top + window.pageYOffset + yOffset;
                // 컨텐츠 영역이 스크롤 목표 위치보다 위에 있을 때만 스크롤
                if (contentArea.getBoundingClientRect().top < 90) {
                    window.scrollTo({ top: targetY, behavior: 'smooth' });
                }
            }
        });
      }
    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntKindCd);

    return(
        <div className="BgW">
            <GamePageBanner gameMainPageData={gameMainPageData} langData={langData} defaultTitle="GUIDES" overrideBackgroundUrl={guideBannerUrl} />
            <div className="container1580 mt30">
                <h1 className="ctntCtgrTitlTxt" style={{justifyContent:"flex-start"}}>
                    <a href="/GamePage/GameGuide?gameSvcCd=BBO&ctntKindCd=GGUID" className="ctntCtgrTitlTxtLink">
                        GUIDES
                    </a>
                    <span style={{margin: '0 25px'}}>
                        <img src={process.env.PUBLIC_URL + '/images/common/rarrIcon.png'} alt="" />
                    </span>
                    {langData&&langData.GLB_PRBB_LINK_BTN}
                </h1>
                <div className="ctntLstWrap ctntPstdLstWrap faqLstContentsWrap">
                <div className="faqLst guideLst">
                    {/* 모바일 카테고리 버튼 */}
                    <button 
                        className="mobileCategoryBtn"
                        onClick={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
                    >
                        <span>
                            {(faqCtgrLstState as any[]).find((cat: any) => cat.ctgrCd === expandedCategory)?.ctgrNm || '카테고리 선택'}
                        </span>
                        <span className={`category-arrow ${isMobileCategoryOpen ? 'up' : 'down'}`}></span>
                    </button>
                    
                    {/* 모바일 배경 오버레이 */}
                    {isMobileCategoryOpen && (
                        <div 
                            className="mobileMenuOverlay"
                            onClick={() => setIsMobileCategoryOpen(false)}
                        />
                    )}
                    
                    <div className={`faqCtgrLstWrap guideCtgrMenu ${isMobileCategoryOpen ? 'mobileOpen' : ''}`}>
                        <ul>
                            {faqCtgrLstState&&faqCtgrLstState.map((category:any)=>(
                                <li key={category.ctgrCd}>
                                    <div 
                                        className={expandedCategory === category.ctgrCd ? "active" : ""} 
                                        onClick={()=>FaqCtgrChngFunc(category.ctgrCd)}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <p>{category.ctgrNm}</p>
                                        {/* 카테고리 열림/닫힘 화살표 */}
                                        <span className={`category-arrow ${expandedCategory === category.ctgrCd ? 'up' : 'down'}`}></span>
                                    </div>
                                    {/* 카테고리가 펼쳐졌을 때 하위 아코디언 목록 표시 */}
                                    {expandedCategory === category.ctgrCd && ctntLstState && ctntLstState.length > 0 && (
                                        <ul className="guideSubAccordionList">
                                            {ctntLstState.map((item:any) => (
                                                <li 
                                                    key={item.ctntSno}
                                                    className={selectedCtntSno === item.ctntSno ? "active" : ""}
                                                    onClick={(e) => handleAccordionClick(item.ctntSno, e)}
                                                    style={{cursor: 'pointer'}}
                                                >
                                                    <p>{item.ctntTitl}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="faqCtxtLstWrap">
                        {selectedCtntSno && ctntCtxtState ? (
                            <div>
                                <h2 className="guideCtxtTitle" style={{marginBottom:"20px"}}>
                                    {ctntLstState?.find((item:any) => item.ctntSno === selectedCtntSno)?.ctntTitl}
                                </h2>
                                <div className="trmsCtxt ctntCtxt faqCtxt guideCtxt" 
                                    dangerouslySetInnerHTML={{
                                        __html: ctntCtxtState,
                                    }}>
                                </div>
                            </div>
                        ) : (
                            <div className="faqNoLst">
                                <NoDataUi noDataDesc={langData&&langData.GLB_NO_DATA_LBL_00}/>
                            </div>
                        )}
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}



export default GamePrbbUi;
